import React, { Component } from 'react';
import { string, bool, func, number, oneOfType } from 'prop-types';
import idGenerator from 'react-id-generator';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './CheckBox.css';

class CheckBox extends Component {
  static propTypes = {
    className: string,
    disabled: bool,
    isChecked: bool,
    label: string.isRequired,
    value: string,
    name: string,
    onClick: func,
    id: oneOfType([string, number])
  };

  state = {
    isChecked: this.props.isChecked || false,
  }

  handleClick = () => {
    const { onClick } = this.props;
    const { isChecked } = this.state;

    onClick && onClick(!isChecked);

    this.setState({
      isChecked: !isChecked
    });
  }

  render() {
    const {
      className,
      label,
      value,
      isChecked,
      id = idGenerator('input-checkbox-')
    } = this.props;

    return (
      <div className={classnames(className, styles.inputField, 'flex-inline flex-align-center')}>
        <input
          name={name}
          value={value}
          type='checkbox'
          disabled={className}
          className={styles.input}
          onClick={this.handleClick}
          defaultChecked={isChecked}
          id={id}
        />
        <Icon icon="checkbox" type="15" responsive />
        <label htmlFor={id} className={styles.inputLabel}>{label}</label>
      </div>
    );
  }
}

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/inputs/CheckBox/CheckBox.js